import { colors } from '@ardoq/design-tokens';

export const BAR_COLOR = colors.borderFocus;
